import { FOOTPRINT_SHAPE_PREVIEW_SIZE } from 'utils/footprint-shapes';

type FootprintShapePreviewProps = Readonly<{
  points: string;
}>;

export default function FootprintShapePreview({
  points
}: FootprintShapePreviewProps) {
  return (
    <svg
      width={48}
      height={48}
      viewBox={`0 0 ${FOOTPRINT_SHAPE_PREVIEW_SIZE} ${FOOTPRINT_SHAPE_PREVIEW_SIZE}`}
    >
      <polygon
        points={points}
        fill='#DBEAFE'
        stroke='#3B82F6'
        strokeWidth={1.5}
        strokeLinejoin='round'
      />
    </svg>
  );
}
